import { FC } from "react"
import { Sliders } from "lucide-react"
import SectionCard from "../../../section-card"
import Input from "../../../form/input"
import URLInput from "./URLInput"

interface Props {
  titleLabel?: string
  urlLabel?: string
}

const GeneralSettingsSection: FC<Props> = ({ titleLabel, urlLabel }) => (
  <SectionCard icon={<Sliders size={15} />} title="General Settings">
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <Input label={titleLabel ?? "Title"} name="title" />
      <URLInput label={urlLabel} />
    </div>
  </SectionCard>
)

export default GeneralSettingsSection
